import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import UploadFileRoundedIcon from '@mui/icons-material/UploadFileRounded';
import { Box, Drawer, IconButton, Stack, Tooltip, Typography } from '@mui/material';

import { ImportPanel } from './ImportPanel';

export interface ImportFlyoutProps {
  open: boolean;
  onClose: () => void;
}

/**
 * Catalog import as a right-anchored slideout (flyout) over the Products
 * workspace. Keeps the operator in context — open it from the "Импорт" button,
 * import, and close back to the product list. The same {@link ImportPanel} also
 * backs the standalone `/catalog/import` page.
 */
export function ImportFlyout({ open, onClose }: ImportFlyoutProps) {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            width: { xs: '100%', sm: 520 },
            maxWidth: '100%',
            borderLeft: (t) => `1px solid ${t.palette.divider}`,
          },
        },
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <Stack
          direction="row"
          spacing={1.5}
          alignItems="center"
          sx={{
            p: 2,
            position: 'sticky',
            top: 0,
            zIndex: 1,
            bgcolor: 'background.paper',
            borderBottom: (t) => `1px solid ${t.palette.divider}`,
          }}
        >
          <Box
            aria-hidden
            sx={{
              display: 'grid',
              placeItems: 'center',
              width: 40,
              height: 40,
              borderRadius: 2,
              flexShrink: 0,
              color: '#fff',
              background: (t) =>
                `linear-gradient(135deg, ${t.palette.primary.light}, ${t.palette.primary.dark})`,
            }}
          >
            <UploadFileRoundedIcon />
          </Box>
          <Box sx={{ minWidth: 0, flexGrow: 1 }}>
            <Typography variant="h6" component="h2" lineHeight={1.2} noWrap>
              Импорт каталога
            </Typography>
            <Typography variant="body2" color="text.secondary" noWrap>
              Загрузка из Excel-файла или Google-таблицы
            </Typography>
          </Box>
          <Tooltip title="Закрыть">
            <IconButton onClick={onClose} aria-label="Закрыть">
              <CloseRoundedIcon />
            </IconButton>
          </Tooltip>
        </Stack>

        <Box sx={{ p: { xs: 2, sm: 2.5 }, overflowY: 'auto', flexGrow: 1 }}>
          <ImportPanel />
        </Box>
      </Box>
    </Drawer>
  );
}
